import { Component, EventEmitter, Input, OnInit, OnChanges, SimpleChanges, Output, HostListener } from '@angular/core';
import { RsaProvided } from '@app/_models/rsaProvided';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
  selector: 'app-rsa-service-history',
  templateUrl: './rsa-service-history.component.html',
  styleUrls: ['./rsa-service-history.component.less'],
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(20px)' }),
        animate('600ms ease-out', style({ opacity: 1, transform: 'translateY(0)' })),
      ]),
    ])
  ]
})
export class RsaServiceHistoryComponent implements OnInit, OnChanges {
  @Input() rsaProvidedList: RsaProvided[] = [];
  @Input() isCertificateExpired = false;
  @Input() loading = false;
  
  @Output() markAsCompleted = new EventEmitter<RsaProvided>();
  @Output() copyContactNumber = new EventEmitter<string>();
  
  // For animation purposes
  isLoaded = false;
  
  // Track viewport width for responsive layout
  viewportWidth: number;

  constructor() {
    this.viewportWidth = window.innerWidth;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.viewportWidth = event.target.innerWidth;
  }

  ngOnInit() {
    // Trigger animation after component initializes
    setTimeout(() => {
      this.isLoaded = true;
    }, 100);
  }
  
  ngOnChanges(changes: SimpleChanges) {
    // Reset and retrigger animation when data changes
    if (changes.rsaProvidedList && !changes.rsaProvidedList.firstChange) {
      this.isLoaded = false;
      setTimeout(() => {
        this.isLoaded = true;
      }, 100);
    }
  }
  
  /**
   * Handle marking a service request as completed
   * @param rsaProvide The service to mark as completed
   */
  onMarkAsCompleted(rsaProvide: RsaProvided) {
    this.markAsCompleted.emit(rsaProvide);
  }
  
  /**
   * Handle copying contact number to clipboard
   * @param contactNumber The contact number to copy
   */
  onCopyContact(contactNumber: string) {
    this.copyContactNumber.emit(contactNumber);
  }
  
  /**
   * Check if the current viewport is mobile
   * @returns True if viewport width is less than 768px
   */
  isMobileView(): boolean {
    return this.viewportWidth < 768;
  }
}
